export default "__VITE_ASSET__CSpXBMVe__"